// src/app/redux/reducers/paramCongesReducer.js
import {
    FETCH_PARAM_CONGES_REQUEST,
    FETCH_PARAM_CONGES_SUCCESS,
    FETCH_PARAM_CONGES_FAIL,
    SET_PARAM_CONGES_LOADING,

    CREATE_ABSENCE_TYPE_SUCCESS,
    UPDATE_ABSENCE_TYPE_SUCCESS,
    DELETE_ABSENCE_TYPE_SUCCESS,

    CREATE_ACQ_RULE_SUCCESS,
    DELETE_ACQ_RULE_SUCCESS,

    CREATE_JUSTIF_RULE_SUCCESS,
    DELETE_JUSTIF_RULE_SUCCESS, UPDATE_JUSTIF_RULE_FAIL, UPDATE_ACQ_RULE_FAIL, UPDATE_ABSENCE_TYPE_FAIL,
    UPDATE_JUSTIF_RULE_SUCCESS, UPDATE_ACQ_RULE_SUCCESS,
} from "../actions/paramCongesActions";

const initialState = {
    loading: false,
    error: null,

    typesAbsences: [],
    reglesAcquisition: [],
    justificatifs: [],
};

export default function paramCongesReducer(state = initialState, action) {
    switch (action.type) {
        case SET_PARAM_CONGES_LOADING:
            return { ...state, loading: action.payload };

        case FETCH_PARAM_CONGES_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_PARAM_CONGES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                typesAbsences: action.payload?.typesAbsences || [],
                reglesAcquisition: action.payload?.reglesAcquisition || [],
                justificatifs: action.payload?.justificatifs || [],
            };

        case FETCH_PARAM_CONGES_FAIL:
            return { ...state, loading: false, error: action.payload };

        // ===== TYPES =====
        case CREATE_ABSENCE_TYPE_SUCCESS:
            return { ...state, typesAbsences: [action.payload, ...state.typesAbsences] };

        case UPDATE_ABSENCE_TYPE_SUCCESS: {
            const updated = action.payload; // AbsenceTypeResponseDTO
            return {
                ...state,
                loading: false,
                typesAbsences: (state.typesAbsences || []).map((t) =>
                    t.id === updated.id ? updated : t
                ),
            };
        }

        case UPDATE_ACQ_RULE_SUCCESS: {
            const updated = action.payload; // AcquisitionRuleResponseDTO
            return {
                ...state,
                loading: false,
                reglesAcquisition: (state.reglesAcquisition || []).map((r) =>
                    r.id === updated.id ? updated : r
                ),
            };
        }

        case UPDATE_JUSTIF_RULE_SUCCESS: {
            const updated = action.payload; // JustificatifRuleResponseDTO
            return {
                ...state,
                loading: false,
                justificatifs: (state.justificatifs || []).map((j) =>
                    j.id === updated.id ? updated : j
                ),
            };
        }

        case UPDATE_ABSENCE_TYPE_FAIL:
        case UPDATE_ACQ_RULE_FAIL:
        case UPDATE_JUSTIF_RULE_FAIL:
            return { ...state, loading: false, error: action.payload };

        case DELETE_ABSENCE_TYPE_SUCCESS:
            return { ...state, typesAbsences: state.typesAbsences.filter((t) => t.id !== action.payload) };

        // ===== ACQUISITION =====
        case CREATE_ACQ_RULE_SUCCESS:
            return { ...state, reglesAcquisition: [action.payload, ...state.reglesAcquisition] };

        case DELETE_ACQ_RULE_SUCCESS:
            return { ...state, reglesAcquisition: state.reglesAcquisition.filter((r) => r.id !== action.payload) };

        // ===== JUSTIFICATIFS =====
        case CREATE_JUSTIF_RULE_SUCCESS:
            return { ...state, justificatifs: [action.payload, ...state.justificatifs] };

        case DELETE_JUSTIF_RULE_SUCCESS:
            return { ...state, justificatifs: state.justificatifs.filter((j) => j.id !== action.payload) };

        default:
            return state;
    }
}
